import { render } from "./_MenuMainLinkInner.vue?vue&type=template&id=006e903a"
import script from "./_MenuMainLinkInner.vue?vue&type=script&lang=js"
export * from "./_MenuMainLinkInner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/evoove-zcd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__